import {Card, Form, Input, InputNumber, Radio, Row, Select, Switch} from 'antd';
import React from "react";
import {IFieldOptionsEditorProps} from "../FieldOptionsEditor";
import IBaseProps from "../../../../../../model/interface/IBaseProps";
import IRestServiceFilters from "../../../../../../model/interface/api/IRestServiceFilters";
import FilterTreeBuilder from "../../../../view/settings/customFilters/FilterTreeBuilder";
import IContentType from "../../../../../../model/interface/dataStorage/IContentType";
import LocaleText from "../../../../settings/dictionary/LocaleText";
import FieldPicker from "../../../../../shared/pickers/FieldPicker";
import {CodeOutlined, SortAscendingOutlined, SortDescendingOutlined} from "@ant-design/icons";
import Search from "antd/es/input/Search";
import IRestResource from "../../../../../../model/interface/api/IRestResource";
import {ButtonTypes} from "../../../../../shared/button/Button";
import {API_FILTER_TYPE} from 'model/constants/ApiConstant';
import {ActionTypes} from "../../../../../../model/interface/dataStorage/IAction";
import IconPicker from "../../../../../shared/IconPicker";
import ButtonTypePicker from "../../../../../shared/button/ButtonTypePicker";
import PresenterPicker from "../../../../../shared/pickers/PresenterPicker";

export interface IFieldContentTypeOptions {
    contentTypeFilters?: IRestServiceFilters
    contentTypeFullClassName?: string
    contentTypePresenter?: string
    contentTypeMode?: "radio" | "select" | "autocomplete" | "auto"
    contentTypeAutocompleteField?: string
    contentTypeOrderField?: string[]|string
    contentTypeOrderDirection?:  'ASC' | "DESC"
    contentTypeAutocompleteMode?: string
    contentTypeAutocompleteMin?: number
    contentTypeCascadeField?: string
    contentTypeAdditionalRows?: IRestResource[]
    contentTypeAllowCreation?: boolean
    contentTypeCreationAction?: string
    contentTypeCreationButtonText?: string
    contentTypeCreationButtonIcon?: string
    contentTypeCreationButtonType?: ButtonTypes
    contentTypeDropdownMatchSelectWidth?: boolean
    contentTypeDropdownHeight?: number
}

interface IProps extends IFieldOptionsEditorProps, IBaseProps {
    targetContentType?: IContentType
    originalContentType?: IContentType
}

class FieldContentTypeOptionsEditor extends React.Component<IProps> {

    render() {
        const {history, match, targetContentType, buildFieldName, originalContentType, options} = this.props
        return <div>

            {targetContentType ? (
                <div>
                    <Form.Item label={"Zobrazení"} name={buildFieldName("contentTypePresenter")} rules={[{required: true}]}>
                        <PresenterPicker serviceClassName={targetContentType.fullClassName}/>
                    </Form.Item>
                    <Form.Item name={buildFieldName('contentTypeFilters')} label={<LocaleText code={'configuration.field.content-type.options.filter'} fallback={'Filter'}/>}>
                        <FilterTreeBuilder history={history} match={match} originalContentTypeFullClassName={originalContentType?.fullClassName}
                                           contentTypeFullClassName={targetContentType.fullClassName}/>
                    </Form.Item>
                    {originalContentType && (
                        <Form.Item name={buildFieldName('dependentFields')} label={<LocaleText code={'configuration.field.content-type.options.depends-on'} fallback={'Závislé na poli'}/>}>
                            <FieldPicker multiple={true} output={'name'} serviceClassName={originalContentType.fullClassName}/>
                        </Form.Item>
                    )}
                </div>
            ) : <></>}

            <Form.Item label={"Řadit směr"} name={buildFieldName("contentTypeOrderDirection")} initialValue={'ASC'}>
                <Select allowClear={true}>
                    <Select.Option key={'asc'} value={"ASC"}>
                        <Row justify={"space-between"} align={"middle"}>
                            Vzestupně<SortAscendingOutlined style={{fontSize: 20}}/>
                        </Row>
                    </Select.Option>
                    <Select.Option key={'desc'} value={"DESC"}>
                        <Row justify={"space-between"} align={"middle"}>
                            Sestupně<SortDescendingOutlined style={{fontSize: 20}}/>
                        </Row>
                    </Select.Option>
                </Select>
            </Form.Item>
            <Form.Item name={buildFieldName('allowSelectAll')} label={<LocaleText code={'configuration.field.content-type.options.pick-all'} fallback={'Povolit výběr všech'}/>} valuePropName={'checked'}>
                <Switch/>
            </Form.Item>
            <Form.Item name={buildFieldName('contentTypeDropdownMatchSelectWidth')} label={<LocaleText code={'configuration.field.content-type.options.dropdown-match-select-width'} fallback={'Rozbalovací nabídka bude odpovídat šířce prvku výběru'}/>} valuePropName={'checked'} initialValue={true}>
                <Switch/>
            </Form.Item>
            <Form.Item name={buildFieldName('contentTypeDropdownHeight')} label={<LocaleText code={'configuration.field.content-type.options.dropdown-height'} fallback={'Výška rozbalovací nabídky'}/>}>
                <InputNumber min={20}/>
            </Form.Item>
            <Form.Item label={"Typ"} name={buildFieldName('contentTypeMode')} rules={[{required: true}]} initialValue={'auto'}>
                <Select>
                    <Select.Option value={'auto'}>
                        <Row justify={"space-between"} align={"middle"}>
                            Automatický
                            <CodeOutlined style={{fontSize: 'large'}}/>
                        </Row>
                    </Select.Option>
                    <Select.Option value={'select'}>
                        <Row justify={"space-between"} align={"middle"}>
                            SelectBox
                            <Select className={'d-inline-block w-auto'} defaultValue={1} size={"small"}>
                                <Select.Option value={1}>test</Select.Option>
                            </Select>
                        </Row>
                    </Select.Option>
                    <Select.Option value={'radio'}>
                        <Row justify={"space-between"} align={"middle"}>
                            Přepínač
                            <Radio className={'d-flex align-items-center'}>Test</Radio>
                        </Row>
                    </Select.Option>
                    <Select.Option value={'autocomplete'}>
                        <Row justify={"space-between"} align={"middle"}>
                            Našeptávač
                            <Search size={"small"} placeholder="search" className={'w-auto'}/>
                        </Row>
                    </Select.Option>
                </Select>
            </Form.Item>

            {targetContentType ? (
                <div>
                    <Form.Item label={"Řadit dle"} name={buildFieldName("contentTypeOrderField")}>
                        <FieldPicker multiple={true} serviceClassName={targetContentType.fullClassName} output={'name'}/>
                    </Form.Item>
                    {options.contentTypeMode === 'autocomplete' && (
                        <div>
                            <Form.Item label={"Hledat podle"} name={buildFieldName("contentTypeAutocompleteField")}
                                       rules={[{required: true}]}>
                                <Select>
                                    <FieldPicker serviceClassName={targetContentType.fullClassName} output={'name'}/>
                                </Select>
                            </Form.Item>
                            <Form.Item label={"Shoda"} name={buildFieldName("contentTypeAutocompleteMode")} rules={[{required: true}]}
                                       initialValue={API_FILTER_TYPE.LIKE}>
                                <Select>
                                    <Select.Option value={API_FILTER_TYPE.LIKE}>{'Uvnitř'}</Select.Option>
                                    <Select.Option value={API_FILTER_TYPE.LIKE_BEGINNING}>
                                        {'Začátek'}
                                    </Select.Option>
                                    <Select.Option
                                        value={API_FILTER_TYPE.EQUAL}>{'Presna hodnota'}
                                    </Select.Option>
                                </Select>
                            </Form.Item>
                            <Form.Item label={"Minimum znaků"} name={buildFieldName("contentTypeAutocompleteMin")} initialValue={2}
                                       rules={[{required: true}]}>
                                <InputNumber/>
                            </Form.Item>
                        </div>
                    )}
                    <Card size={"small"}>
                        <Form.Item label={'Povolit založit nový záznam'} name={buildFieldName('contentTypeAllowCreation')}
                                   valuePropName={'checked'}>
                            <Switch/>
                        </Form.Item>
                        {options.contentTypeAllowCreation && (
                            <div>
                                <Form.Item label={'Akce pro založení'} name={buildFieldName('contentTypeCreationAction')} help={'Pouze akce s povoleným modálním zobrazením a bez přesměrování'}>
                                    <Select>
                                        {targetContentType.actions.filter(a => a.type === ActionTypes.FORM && a.modal && !a.afterRedirect).map(a => (
                                            <Select.Option value={a.uuid} key={a.uuid}>{a.label}</Select.Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                                <Form.Item label={'Text tlačítka pro založení'} name={buildFieldName('contentTypeCreationButtonText')}>
                                    <Input/>
                                </Form.Item>
                                <Form.Item label={'Ikona tlačítka založení'} name={buildFieldName('contentTypeCreationButtonIcon')}
                                           initialValue={'ant.PlusOutlined'}>
                                    <IconPicker/>
                                </Form.Item>
                                <Form.Item label={'Typ tlačítka'} name={buildFieldName('contentTypeCreationButtonType')}
                                           initialValue={'default'}>
                                    <ButtonTypePicker className={'w-100'}/>
                                </Form.Item>
                            </div>
                        )}
                    </Card>
                </div>
            ) : <></>}
        </div>
    }
}


export default FieldContentTypeOptionsEditor